import {Context, EMPTY_CONTEXT, Options, Schema} from './schema';

export interface BooleanOptions extends Options<boolean | null> {}

export class BooleanSchema extends Schema<boolean | null, BooleanOptions> {
  constructor(options: BooleanOptions = {}) {
    super(options);
  }

  public toJSON(): object {
    return {
      type: 'BooleanSchema',
      ...super.toJSON(),
    };
  }

  public valueToMobx(value: boolean | null): boolean | null {
    return this._nullifyValue(value);
  }

  public valueToJS(
    value?: boolean | null,
    context: Context = EMPTY_CONTEXT,
  ): boolean | null {
    return this.isComputed
      ? this.computedValue(context)
      : this._nullifyValue(value);
  }

  public typeIsValid(value: any): value is boolean | null {
    return value === null || typeof value === 'boolean';
  }

  public valueIsValid(
    value: boolean | null,
    context: Context = EMPTY_CONTEXT,
  ): boolean {
    return (
      this.requiredIsValid(value, context) &&
      this.customFunctionIsValid(value, context)
    );
  }
}
